import { createStore, Plugin, PluginFunctions } from '@react-pdf-viewer/core';
import * as React from 'react';

interface StoreProps {
  jumpToPage?(_pageIndex: number): void;
}

interface JumpToPagePlugin extends Plugin {
  jumpToPage(_pageIndex: number): void;
}

const jumpToPagePlugin = (): JumpToPagePlugin => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = React.useMemo(() => createStore<StoreProps>(), []);

  return {
    install: (pluginFunctions: PluginFunctions) => {
      store.update('jumpToPage', pluginFunctions.jumpToPage);
    },
    jumpToPage: (pageIndex: number) => {
      const fn = store.get('jumpToPage');
      if (fn) {
        fn(pageIndex);
      }
    },
  };
};

export default jumpToPagePlugin;
